export default {
  INIT(state: any) {
    state.initCounter = state.initCounter++; 
  },
  SET_LOGGED(state: any) {
    state.logged = true;
  },
  SET_LOGGED_OUT(state: any) {
    state.logged = false;
  },
};
